import { createValidator } from 'revalidate';
import { INVALID_UPI_COLLECT_ID } from '../constants/defaultErrorMessages';
const isValidUpiCollectId = () => createValidator(message => value => {
  const validUpiFormat = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;
  if (value && !validUpiFormat.test(value)) {
    return message || INVALID_UPI_COLLECT_ID;
  }
  return null;
}, INVALID_UPI_COLLECT_ID);
export default isValidUpiCollectId;